module.exports = __webpack_public_path__ + "b960b04df32e5a7a7734ed04f9b61d1a.MP3";